import React from "react";
import _ from "lodash";
import SkeletonLoader from "UIComponents/SkeletonLoader";
import classes from "./SchoolList.scss";

const SKELETON_ROW_COUNT = 5;

const SchoolListSkeleton = () => {
  return (
    <div className={classes.skeletonContainer}>
      {_.times(SKELETON_ROW_COUNT, index => (
        <div key={`school-skeleton-${index}`} className={classes.skeletonRow}>
          <SkeletonLoader width="36px" height="36px" borderRadius="4px" />
          <div className={classes.skeletonText}>
            <SkeletonLoader width="140px" height="14px" />
            <SkeletonLoader width="220px" height="12px" />
          </div>
        </div>
      ))}
    </div>
  );
};

export default SchoolListSkeleton;
